import { CampaignCategoryStats } from '@/types';
import { formatCurrency } from '@/utils/currencyUtils';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { TableRow, TableCell } from '@/components/Table';
import { getChartColor } from '@/utils/colorUtils';

interface LegendRowProps {
  data: {
    index: number;
    type: string;
    stats: CampaignCategoryStats;
    categories: Record<string, CampaignCategoryStats>;
  };
  selectedCategory: string | null;
}

export const LegendRow = memo(({ data, selectedCategory }: LegendRowProps) => {
  const { index, type, stats, categories } = data;
  const isSelected = selectedCategory === stats.name;
  const isOtherSelected = selectedCategory !== null && !isSelected;

  return (
    <TableRow key={`campaign-${type}`} isOtherRowSelected={isOtherSelected}>
      <TableCell className="w-10">
        <div
          className={`w-3 h-3 rounded-full bg-${getChartColor(
            index % Object.keys(categories).length
          )}`}
        />
      </TableCell>
      <TableCell>
        <p className={twMerge('capitalize font-medium')}>{stats.name}</p>
      </TableCell>

      <TableCell align="right">
        <p>{formatCurrency(stats.total.amount, stats.total.currency)}</p>
      </TableCell>
    </TableRow>
  );
});

LegendRow.displayName = 'CampaignRow';
